import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=7051a4fa&scoped=true"
import script from "./Dictionary.vue?vue&type=script&lang=js"
export * from "./Dictionary.vue?vue&type=script&lang=js"
import style0 from "./Dictionary.vue?vue&type=style&index=0&id=7051a4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7051a4fa",
  null
  
)

export default component.exports